import React from 'react';
import { services } from '../data/mock';
import { Sparkles, Music, CheckCircle } from 'lucide-react';

const iconMap = {
  'Sparkles': Sparkles,
  'Music': Music,
  'CheckCircle': CheckCircle
};

const Services = () => {
  return (
    <section id="services" className="py-24 px-6 bg-zinc-900">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-font text-5xl md:text-6xl font-bold text-white mb-4">
            Our Services
          </h2>
          <div className="w-24 h-1 gold-bg mx-auto mb-6"></div>
          <p className="body-font text-xl text-gray-300 max-w-3xl mx-auto">
            Comprehensive entertainment solutions tailored to your conference needs
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="service-card bg-black p-10 rounded-sm border border-zinc-700 hover:border-yellow-600 transition-all group"
              >
                <div className="gold-bg w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <IconComponent className="text-black" size={32} />
                </div>
                <h3 className="heading-font text-2xl font-bold text-white mb-4">
                  {service.title}
                </h3>
                <p className="body-font text-gray-400 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
